export const TITLE_TILE_COLORS = {
  accent: 0xe2c792,
  base: 0xe8cf9e,
} as const;

export function getTitleTileColor(letter: string) {
  return letter === "A" ? TITLE_TILE_COLORS.accent : TITLE_TILE_COLORS.base;
}
